import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

// Native port of the legacy disassociateVendorsModal
// (src/app/public/app/partials/missioncontrol/company/disassociateVendorsModal) -
// opened from company-page.component.js's launchDisassociateVendorsModal
// (component: 'disassociateVendorsModal'). The modal body embeds the
// already-native <app-delete-entity entity="buVendorRelationship"> component
// unchanged - this wrapper only replaces the legacy $uibModal chrome around
// it with BsModalService, same pattern as
// CompanyPageDeleteAssessmentCredentialModalComponent.
//
// Matches the legacy behavior exactly: the legacy modal's own `note` was
// always hardcoded to "" via its `$uibModal.open` resolve (never actually
// wired to the text typed into delete-entity's own note textarea), so
// `deleteCallback` here likewise carries no note payload.
@Component({
  selector: 'app-company-page-disassociate-vendors-modal',
  templateUrl: './company-page-disassociate-vendors-modal.component.html'
})
export class CompanyPageDisassociateVendorsModalComponent implements OnInit {

  public onClose: Subject<any>;

  modalData: any = {};

  buVendorsInfo: any;

  callbackObject: any = { callbackType: 'cancel', entity: {} };

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
    this.buVendorsInfo = this.modalData.buVendorsInfo;
  }

  onDisassociateVendors() {
    this.callbackObject = { callbackType: 'disassociate', entity: { note: '' } };
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }

  closeModal() {
    this.callbackObject = { callbackType: 'cancel', entity: {} };
    this.onClose.next(this.callbackObject);
    this.bsModalRef.hide();
  }
}
